var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwoPersonsCheckmarkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2659_68010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.5C15.5 12.2911 15.2654 13.0645 14.8259 13.7223C14.3864 14.3801 13.7616 14.8928 13.0307 15.1955C12.2998 15.4983 11.4956 15.5775 10.7196 15.4231C9.94372 15.2688 9.23098 14.8878 8.67157 14.3284C8.11216 13.769 7.7312 13.0563 7.57686 12.2804C7.42252 11.5044 7.50173 10.7002 7.80448 9.96927C8.10723 9.23836 8.61992 8.61365 9.27772 8.17412C9.93552 7.7346 10.7089 7.5 11.5 7.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.49902L11.8533 12.1457C11.807 12.1921 11.7519 12.229 11.6913 12.2541C11.6306 12.2793 11.5656 12.2922 11.5 12.2922C11.4344 12.2922 11.3694 12.2793 11.3087 12.2541C11.2481 12.229 11.193 12.1921 11.1467 12.1457L10 10.9997",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.188 7.00879C6.44598 6.35437 5.48937 5.9954 4.5 6.00012C3.52034 5.99244 2.57192 6.34456 1.83462 6.98969C1.09733 7.63483 0.622432 8.52811 0.5 9.50012",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 2.75C2.25 3.34674 2.48705 3.91903 2.90901 4.34099C3.33097 4.76295 3.90326 5 4.5 5C5.09674 5 5.66903 4.76295 6.09099 4.34099C6.51295 3.91903 6.75 3.34674 6.75 2.75C6.75 2.15326 6.51295 1.58097 6.09099 1.15901C5.66903 0.737053 5.09674 0.5 4.5 0.5C3.90326 0.5 3.33097 0.737053 2.90901 1.15901C2.48705 1.58097 2.25 2.15326 2.25 2.75V2.75Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 2.25C9.25 2.71413 9.43437 3.15925 9.76256 3.48744C10.0908 3.81563 10.5359 4 11 4C11.4641 4 11.9092 3.81563 12.2374 3.48744C12.5656 3.15925 12.75 2.71413 12.75 2.25C12.75 1.78587 12.5656 1.34075 12.2374 1.01256C11.9092 0.684374 11.4641 0.5 11 0.5C10.5359 0.5 10.0908 0.684374 9.76256 1.01256C9.43437 1.34075 9.25 1.78587 9.25 2.25V2.25Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6001 6.00026C13.3614 5.58712 13.0276 5.23687 12.6265 4.97858C12.2253 4.72029 11.7683 4.56141 11.2934 4.51512C10.8185 4.46884 10.3395 4.53649 9.89598 4.71246C9.45249 4.88843 9.05737 5.16765 8.74341 5.52692",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2659_68010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoPersonsCheckmarkIcon);
export default __webpack_public_path__ + "static/media/TwoPersonsCheckmarkIcon.fd83ea4227a21e38cb24b744ce81e4c2.svg";
export { ForwardRef as ReactComponent };